import React from 'react';
import styles from './Title.module.scss';
import { sanitizeType } from '../../../../functions';

const Title = ({ title, type, children, animationData }) => {
  return (
    !!title && (
      <h2
        data-aos={animationData?.animation}
        data-aos-offset={animationData?.animationOffset}
        data-aos-delay={animationData?.animationDelay}
        data-aos-duration={animationData?.animationDuration}
        data-aos-easing={animationData?.animationEasing}
        data-aos-once={animationData?.animationOnce}
        // data-aos-anchor-placement="top-center"
        className={`${styles.title} ${sanitizeType(type, styles)}`}
      >
        {title} {children}
      </h2>
    )
  );
};
export default Title;
